"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.replaceParams = exports.validatePath = exports.parseSearch = exports.matchPath = exports.createNamedContext = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/get-iterator"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/slice"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _matchAll = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/match-all"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

// Create a React Context with the given name.
var createNamedContext = function createNamedContext(name, defaultValue) {
  var Ctx = _react.default.createContext(defaultValue);

  Ctx.displayName = name;
  return Ctx;
}; // Get param name and type tranform for a route
//
// '/blog/{year}/{month}/{day:Int}' => [['year'], ['month'], ['day', 'Int']]


exports.createNamedContext = createNamedContext;

var paramsForType = function paramsForType(route) {
  var _context;

  // Match the strings between `{` and `}`.
  var params = (0, _toConsumableArray2.default)((0, _matchAll.default)(route).call(route, /\{([^}]+)\}/g));
  return (0, _map.default)(_context = (0, _map.default)(params).call(params, function (match) {
    return match[1];
  })).call(_context, function (match) {
    return match.split(':');
  });
}; // Definitions of the core param types.


var coreParamTypes = {
  Int: {
    constraint: /\d+/,
    transform: Number
  }
}; // Determine if the given route is a match for the given pathname. If so,
// extract any named params and return them in an object.
//
// route         - The route path as specified in the <Route path={...} />
// pathname      - The pathname from the window.location.
// allParamTypes - The object containing all param type definitions.
//
// Examples:
//
//   matchPath('/blog/{year}/{month}/{day}', '/blog/2019/12/07')
//   => { match: true, params: { year: '2019', month: '12', day: '07' }}
//
//   matchPath('/about', '/')
//   => { match: false }
//
//   matchPath('/post/{id:Int}', '/post/7')
//   => { match: true, params: { id: 7 }}

var matchPath = function matchPath(route, pathname, paramTypes) {
  var _context2, _context3;

  // Does the `pathname` match the `route`?
  var matches = (0, _toConsumableArray2.default)((0, _matchAll.default)(pathname).call(pathname, "^".concat(route.replace(/\{([^}]+)\}/g, '([^/]+)'), "$")));

  if (matches.length === 0) {
    return {
      match: false
    };
  }

  var allParamTypes = (0, _objectSpread3.default)({}, coreParamTypes, {}, paramTypes); // Get the names and the transform types for the given route.

  var paramInfo = paramsForType(route);
  var params = (0, _reduce.default)(_context2 = (0, _slice.default)(_context3 = matches[0]).call(_context3, 1)).call(_context2, function (acc, value, index) {
    var _paramInfo$index = (0, _slicedToArray2.default)(paramInfo[index], 2),
        name = _paramInfo$index[0],
        transformName = _paramInfo$index[1];

    if (transformName) {
      value = allParamTypes[transformName].transform(value);
    }

    return (0, _objectSpread3.default)({}, acc, (0, _defineProperty2.default)({}, name, value));
  }, {});
  return {
    match: true,
    params: params
  };
}; // Parse the given search string into key/value pairs and return them in an
// object.
//
// Examples:
//
//   parseSearch('?key1=val1&key2=val2')
//   => { key1: 'val1', key2: 'val2' }


exports.matchPath = matchPath;

var parseSearch = function parseSearch(search) {
  if (search === '') {
    return {};
  }

  var searchPart = search.substring(1);
  var pairs = searchPart.split('&');
  var searchProps = {};
  (0, _forEach.default)(pairs).call(pairs, function (pair) {
    var keyval = pair.split('=');
    searchProps[keyval[0]] = keyval[1] || '';
  });
  return searchProps;
}; // Validate a path to make sure it follows the router's rules. If any problems
// are found, a descriptive Error will be thrown, as problems with routes are
// critical enough to be considered fatal.


exports.parseSearch = parseSearch;

var validatePath = function validatePath(path) {
  // Check that path begins with a slash.
  if (path[0] !== '/') {
    throw new Error('Route path does not begin with a slash: "' + path + '"');
  } // Check for duplicate named params.


  var matches = (0, _matchAll.default)(path).call(path, /\{([^}]+)\}/g);
  var memo = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator2.default)(matches), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var match = _step.value;
      var param = match[0];

      if (memo[param]) {
        throw new Error('Route path contains duplicate parameter: "' + path + '"');
      } else {
        memo[match[0]] = true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}; // Take a given route path and replace any named parameters with those in the
// given args object. Any extra params not used in the path will be appended
// as key=value pairs in the search part.
//
// Examples:
//     replaceParams('/tags/{tag}', { tag: 'code', extra: 'foo' })
//     => '/tags/code?extra=foo


exports.validatePath = validatePath;

var replaceParams = function replaceParams(path) {
  var _context4;

  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Split the path apart and replace named parameters with those sent in,
  // then join it back together.
  var parts = path.split('/');
  var newPath = (0, _map.default)(parts).call(parts, function (part) {
    if (part[0] === '{' && part[part.length - 1] === '}') {
      var paramSpec = part.substr(1, part.length - 2);
      var paramName = paramSpec.split(':')[0];
      var arg = args[paramName];

      if (arg) {
        delete args[paramName];
        return arg;
      }
    }

    return part;
  }).join('/'); // Prepare any unnamed params to be be appended as search params.

  var queryParams = [];
  (0, _forEach.default)(_context4 = (0, _keys.default)(args)).call(_context4, function (key) {
    var _context5;

    queryParams.push((0, _concat.default)(_context5 = "".concat(key, "=")).call(_context5, args[key]));
  }); // Append any unnamed params as search params.

  if (queryParams.length) {
    newPath += "?".concat(queryParams.join('&'));
  }

  return newPath;
};

exports.replaceParams = replaceParams;